import * as PIXI from 'pixi.js';
import { HEIGHT, WIDTH } from '@/constants';
import { EVENT_BUS } from '@/model/event-bus';
import { shake } from '@/util/tween';

const SPEED = 2;

export class Parallax extends PIXI.Container {
    constructor(layerUrls) {
        super();
        layerUrls.map(url => {
            const sprite = new PIXI.TilingSprite(
                PIXI.Texture.from(url)
            );
            sprite.width = WIDTH;
            sprite.height = HEIGHT;
            sprite.anchor.set(0.5, 0.5);
            this.addChild(sprite);
            return sprite;
        });
        this.initTicker();
        this.position.set(WIDTH / 2, HEIGHT / 2);
    }

    initTicker() {
        PIXI.Ticker.shared.add(() => {
            this.children.forEach((layer, index) => {
                layer.tilePosition.x += SPEED * index;
            })
        });

        EVENT_BUS.on('GAME_BEAT', () => {
            shake(this.children[2], 6, 300);
        })
    }
}

const variants = ['cake','castle','hill','woods'];
const URLS = {
    'cake': [
        'public/images/parallax/cake/layer06_sky.png',
        'public/images/parallax/cake/layer05_rocks.png',
        'public/images/parallax/cake/layer04_clouds.png',
        'public/images/parallax/cake/layer03_trees.png',
        'public/images/parallax/cake/layer02_cake.png',
        'public/images/parallax/cake/layer01_ground.png',
    ],
    'castle': [
        'public/images/parallax/castle/layer09_Sky.png',
        'public/images/parallax/castle/layer08_Stars_1.png',
        'public/images/parallax/castle/layer07_Stars_2.png',
        'public/images/parallax/castle/layer06_Stars_3.png',
        'public/images/parallax/castle/layer05_Castle.png',
        'public/images/parallax/castle/layer04_Path.png',
        'public/images/parallax/castle/layer03_Clouds_3.png',
        'public/images/parallax/castle/layer02_Clouds_2.png',
        'public/images/parallax/castle/layer01_Clouds_1.png',
    ],
    'hill': [
        'public/images/parallax/hill/layer07_Sky.png',
        'public/images/parallax/hill/layer06_Rocks.png',
        'public/images/parallax/hill/layer05_Hills.png',
        'public/images/parallax/hill/layer04_Clouds.png',
        'public/images/parallax/hill/layer03_Hills_Castle.png',
        'public/images/parallax/hill/layer02_Trees_rocks.png',
        'public/images/parallax/hill/layer01_Ground.png',
    ],
    'woods': [
        'public/images/parallax/woods/layer07_Sky.png',
        'public/images/parallax/woods/layer06_Rocks.png',
        'public/images/parallax/woods/layer05_Clouds.png',
        'public/images/parallax/woods/layer04_Hills_2.png',
        'public/images/parallax/woods/layer03_Hills_1.png',
        'public/images/parallax/woods/layer02_Trees.png',
        'public/images/parallax/woods/layer01_Ground.png',
    ]
};

function getVariantUrls(variant) {
    return URLS[variant];
}

export function createRandomParallax() {
    let variant = Math.trunc( Math.random () * variants.length);
    if (variant > 3 ) {
        variant = 3;
    }
    return new Parallax(getVariantUrls(variants[variant]));
}